<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="供应商管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],

	data() {
		return {
			editorDataModel: "Supplier",
			tableFields: [
				{
					name: "name",
					sortable: "custom"
				},
				{
					name: "phone",
					sortable: false
				},
				{
					name: "contact",
					sortable: false
				}
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"]
				},
				{
					name: "phone"
				},
				{
					name: "contact"
				}
			]
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
